import { Card, CardContent } from "@/components/ui/card"
import { Tagline } from "@/components/pro-blocks/landing-page/tagline"

export function StatsSection4() {
  return (
    <section className="bg-background section-padding-y border-b">
      <div className="container-padding-x container mx-auto">
        <div className="flex flex-col gap-10 md:gap-12">
          <div className="section-title-gap-lg mx-auto flex max-w-xl flex-col items-center text-center">
            <Tagline>Результаты</Tagline>
            <h2 className="heading-lg text-foreground">Цифры говорят сами за себя</h2>
            <p className="text-muted-foreground">
              Проверенные результаты от продакт-менеджеров, которые уже используют FeedbackIQ
            </p>
          </div>

          <div className="flex flex-col gap-4 md:gap-6 lg:flex-row">
            <Card className="bg-secondary flex-1 rounded-xl border-none p-6 shadow-none">
              <CardContent className="flex flex-col gap-2 p-0 md:gap-3">
                <h3 className="text-primary font-semibold">Экономия времени</h3>
                <span className="text-foreground text-3xl font-semibold md:text-4xl">6.5 часов</span>
                <p className="text-muted-foreground text-base">
                  Среднее время экономии в неделю на анализе обращений клиентов
                </p>
              </CardContent>
            </Card>

            <Card className="bg-secondary flex-1 rounded-xl border-none p-6 shadow-none">
              <CardContent className="flex flex-col gap-2 p-0 md:gap-3">
                <h3 className="text-primary font-semibold">Скорость обнаружения</h3>
                <span className="text-foreground text-3xl font-semibold md:text-4xl">24 часа</span>
                <p className="text-muted-foreground text-base">
                  Среднее время обнаружения критических проблем (было 5-7 дней)
                </p>
              </CardContent>
            </Card>

            <Card className="bg-secondary flex-1 rounded-xl border-none p-6 shadow-none">
              <CardContent className="flex flex-col gap-2 p-0 md:gap-3">
                <h3 className="text-primary font-semibold">Точность анализа</h3>
                <span className="text-foreground text-3xl font-semibold md:text-4xl">90%</span>
                <p className="text-muted-foreground text-base">Точность автоматической категоризации обращений</p>
              </CardContent>
            </Card>
          </div>
        </div>
      </div>
    </section>
  )
}
